class ShareButtons {
  constructor(container) {
    this.container = container;
    this.elements = {
      shareButtons: this.container.querySelectorAll('.ir-temp-share-btn'),
      fallback: this.container.querySelector('.ir-temp-share-fallback'),
      successMessage: this.container.querySelector('[id^="ShareMessage"]'),
      urlInput: this.container.querySelector('input'),
      closeButton: this.container.querySelector('.ir-temp-share-close'),
    };
    
    this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
    this.pageTitle = document.title;
    
    this.init();
  }

  init() {
    this.elements.shareButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const shareType = button.dataset.shareType;
        this.handleShare(shareType);
      });
    });

    if (this.elements.closeButton) {
      this.elements.closeButton.addEventListener('click', () => {
        this.hideFallback();
      });
    }
  }

  handleShare(shareType) {
    switch (shareType) {
      case 'mail':
        this.shareViaEmail();
        break;
      case 'copy':
        this.copyToClipboard();
        break;
      case 'facebook':
        this.shareViaFacebook();
        break;
      case 'linkedin':
        this.shareViaLinkedIn();
        break;
    }
  }

  shareViaEmail() {
    const subject = encodeURIComponent(`Check out this: ${this.pageTitle}`);
    const body = encodeURIComponent(`I thought you might be interested in this:\n\n${this.pageTitle}\n${this.urlToShare}`);
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
    window.open(mailtoLink, '_self');
  }

  copyToClipboard() {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.showSuccessMessage();
      }).catch(() => {
        this.showFallback();
      });
    } else {
      this.showFallback();
    }
  }

  shareViaFacebook() {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.urlToShare)}`;
    this.openShareWindow(facebookUrl, 'Facebook Share');
  }

  shareViaLinkedIn() {
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.urlToShare)}`;
    this.openShareWindow(linkedinUrl, 'LinkedIn Share');
  }

  openShareWindow(url, title) {
    const width = 600;
    const height = 400;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    
    window.open(url, title, `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
  }

  showFallback() {
    if (this.elements.fallback) {
      this.elements.fallback.style.display = 'block';
      this.elements.urlInput.focus();
      this.elements.urlInput.select();
    }
  }

  hideFallback() {
    if (this.elements.fallback) {
      this.elements.fallback.style.display = 'none';
    }
  }

  showSuccessMessage() {
    if (this.elements.successMessage) {
      this.elements.successMessage.classList.remove('hidden');
      this.elements.successMessage.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied to clipboard!';
      
      setTimeout(() => {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
      }, 3000);
    }
  }

  updateUrl(url) {
    this.urlToShare = url;
    if (this.elements.urlInput) {
      this.elements.urlInput.value = url;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const shareContainers = document.querySelectorAll('.ir-temp-share-container');
  shareContainers.forEach(container => {
    new ShareButtons(container);
  });
});
